import React, { useState, useMemo } from 'react';
import '../../styles/dash/Roles.css';

import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    flexRender,
    ColumnDef,
} from '@tanstack/react-table';

interface Role {
    id: number;
    name: string;
    status: number;
}

const RolesTable = () => {
    const [filter, setFilter] = useState('');

    const columns: ColumnDef<Role>[] = [
        {
            accessorKey: 'name',
            header: 'Rol',
        },
        {
            accessorKey: 'status',
            header: 'Estado',
            cell: ({ getValue }) => (getValue() === 1 ? 'Activo' : 'Inactivo'),
        },
    ];

    const generateFakeRoles = (count: number): Role[] => {
        return Array.from({ length: count }, (_, index) => ({
            id: index + 1,
            name: `Role ${index + 1}`,
            status: index % 2 === 0 ? 1 : 0,
        }));
    };

    const fakeRoles = useMemo(() => generateFakeRoles(1000), []);

    const table = useReactTable({
        data: fakeRoles,
        columns,
        state: {
            globalFilter: filter,
        },
        onGlobalFilterChange: setFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
    });

    function getPaginationRange(current: number, total: number): (number | string)[] {
        const delta = 1;
        const range: (number | string)[] = [];
        const rangeWithDots: (number | string)[] = [];
        let l = 0;

        for (let i = 1; i <= total; i++) {
            if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                range.push(i);
            }
        }

        for (let i of range) {
            if (l > 0) {
                if (Number(i) - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (Number(i) - l !== 1) {
                    rangeWithDots.push("...");
                }
            }
            rangeWithDots.push(i);
            l = Number(i);
        }

        return rangeWithDots;
    }

    return (


        
                            

        <div className="roles-table-wrapper">
            <input
                type="text"
                placeholder="Buscar rol..."
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="global-filter"
            />

            <table className="demo-request-table">
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="pagination-controls">
                <button
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                >
                    ←
                </button>

                {getPaginationRange(
                    table.getState().pagination.pageIndex + 1,
                    table.getPageCount()
                ).map((page, idx) =>
                    page === "..." ? (
                        <span key={idx} className="dots">...</span>
                    ) : (
                        <button
                            key={idx}
                            className={table.getState().pagination.pageIndex + 1 === page ? "active-page" : ""}
                            onClick={() => table.setPageIndex(Number(page) - 1)}
                        >
                            {page}
                        </button>
                    )
                )}

                <button
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                >
                    →
                </button>
            </div>
        </div>
    );
};

export default RolesTable;
